// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file
/// <reference path="../typings/global.d.ts" />


export class RebateContractorTypeAhead {

	public static Init(contractorTypeaheadName: string) {

		RebateContractorTypeAhead.SetupTypeahead(contractorTypeaheadName);
		RebateContractorTypeAhead.BindFieldHandlers(contractorTypeaheadName);

	}

	public static ResetContractorLookup() {
		$("#ApplicationInformation_RebatePayeeContractorCompanyId").val("");
		$("#ApplicationInformation_RebatePayeeContractorCompanyTypeahead").val("");
		$("#ApplicationInformation_RebatePayeeContractorManualEntry").prop("checked", false);
		RebateContractorTypeAhead.ClearContractorFields();
	}

	private static SetupTypeahead(contractorTypeaheadName: string) {

		//Setup the contractor typeahead
		$("#loadingSpinner").hide();
		var xhr;
		var timeout;
		var map = {};
		var objects = [];

		$("#" + contractorTypeaheadName).typeahead({
			highlight: true,
		},
			{
				limit: 20,
				source: (query, syncResults, asyncResults) => {
					if (query.length < 3) {
						return;
					}
					if (timeout) {
						clearTimeout(timeout);
						timeout = null;
					}

					if (xhr) {
						xhr.abort();
					}

					timeout = setTimeout(() => {
						$("#loadingSpinner").show();

						var url = `${window.location.origin}/api/Company/search?term=`;

						xhr = $.getJSON(url + query, (data) => {
							map = {};
							objects = [];
							$.each(data, (i, object) => {
								map[object.CompanyName] = object;
								objects.push(object.CompanyName);
							});
							asyncResults(objects);
							$("#loadingSpinner").hide();

							clearTimeout(timeout);
							timeout = null;
							xhr = null;
						});
					}, 400);
				},
				templates: {
					notFound: [
						'<div class="px-2">No Results Found</div>'
					].join('\n')
				}
			}).on("keyup", (e) => {
				//Ignore tab
				if (e.keyCode != 9) {
					$("#ApplicationInformation_RebatePayeeContractorCompanyId").val("");
				}
			});

		$("#" + contractorTypeaheadName).on('typeahead:selected', (evt, item) => {

			$("#ApplicationInformation_RebatePayeeContractorCompanyId").val(map[item].CompanyId);
			this.UpdateContractorSelection();
		});

	}

	private static BindFieldHandlers(contractorTypeaheadName: string) {

		$("#" + contractorTypeaheadName).on("blur", () => {
			console.log("blur: " + $("#ApplicationInformation_RebatePayeeContractorCompanyId").val());

			var rid = $("#ApplicationInformation_RebatePayeeContractorCompanyId").val();
			if (rid == "" || rid == null) {
				RebateContractorTypeAhead.SetContractorTypeaheadError(contractorTypeaheadName, "Please select an address from the list.");
				$("#" + contractorTypeaheadName).val("");
				RebateContractorTypeAhead.ClearContractorFields();
			} else {
				RebateContractorTypeAhead.SetContractorTypeaheadError(contractorTypeaheadName, "");
			}
		});
	}

	private static UpdateContractorSelection() {

		var contractorIdToFind = $('#ApplicationInformation_RebatePayeeContractorCompanyId').val();
		var url = `${window.location.origin}/api/Company/contact/${contractorIdToFind}`;
		return $.getJSON(url, (jsonData) => {

			$('#ApplicationInformation_RebatePayeeContractorCompanyName').val(jsonData.Company);
			$('#ApplicationInformation_RebatePayeeContractorFirstName').val(jsonData.FirstName);
			$('#ApplicationInformation_RebatePayeeContractorLastName').val(jsonData.LastName);

			$('#ApplicationInformation_RebatePayeeContractorCity').val(jsonData.City);
			$('#ApplicationInformation_RebatePayeeContractorAddress').val(jsonData.Address);
			$('#ApplicationInformation_RebatePayeeContractorAddress2').val(jsonData.AddressCont);
			$('#ApplicationInformation_RebatePayeeContractorState').val(jsonData.State);
			$('#ApplicationInformation_RebatePayeeContractorZipCode').val(jsonData.Zip);
			$('#ApplicationInformation_RebatePayeeContractorPhoneNumber').val(jsonData.Phone);
			(<any>$("#ApplicationInformation_RebatePayeeContractorPhoneNumber")).mask("(000) 000-0000")
		});
	}

	private static SetContractorTypeaheadError(id, message) {
		var span = $("span[data-valmsg-for=\"" + id + "\"]");
		if (span && span.length > 0) {
			$(span).html(message);
			if (message && message != "") {
				$(span).removeClass("field-validation-valid");
				$(span).addClass("field-validation-no-valid");
			} else {
				$(span).removeClass("field-validation-no-valid");
				$(span).addClass("field-validation-valid");
			}
		}
	}

	private static ClearContractorFields() {
		$("#rebate-contractor-fields").find("input:text").val("");
		$('#ApplicationInformation_RebatePayeeContractorPhoneNumber').val("");
		(<any>$('#ApplicationInformation_RebatePayeeContractorPhoneNumber')).unmask();
	}

}